var DOWN_ARROW, ENTER, ESCAPE, KEYLIST, Keypress, LEFT_ARROW, RIGHT_ARROW, TAB, UP_ARROW, base, base1, isCharKeyPress, isDownArrowKey, isEnterKey, isEscapeKey, isTabKey, isUpArrowKey, isValidCharKeyPress, isValidKeyPress, whichKeyAlias;

TAB = 9;

ENTER = 13;

ESCAPE = 27;

DOWN_ARROW = 40;

RIGHT_ARROW = 39;

UP_ARROW = 38;

LEFT_ARROW = 37;

KEYLIST = {
  9: 'Tab',
  13: 'Enter',
  27: 'Escape',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown'
};

isTabKey = function(key) {
  return key === TAB;
};

isEnterKey = function(key) {
  return key === ENTER;
};

isEscapeKey = function(key) {
  return key === ESCAPE;
};

isUpArrowKey = function(key) {
  return key === UP_ARROW;
};

isDownArrowKey = function(key) {
  return key === DOWN_ARROW;
};


/*
 * Assert if key pressed is a normal character key
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key pressed is a normal character key
 */

isValidCharKeyPress = function(e) {
  if (e.which == null) {
    return false;
  }
  if (!isCharKeyPress(e)) {
    return false;
  }
  if (!isValidKeyPress(e.which)) {
    return false;
  }
  return true;
};


/*
 * Assert if key code is valid
 * and wasn't pressed with extra control keys
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key wasn't pressed with control keys
 */

isCharKeyPress = function(e) {
  if (typeof e.which === 'number' && e.which > 0) {
    return !e.ctrlKey && !e.metaKey && !e.altKey;
  }
  return false;
};


/*
 * Assert if key code is a navigational key
 *
 * @param   {Number}  key - Key code
 * @returns {Boolean}     - Assert if key is not a navigational key
 */

isValidKeyPress = function(key) {
  return !(key === TAB || key === ENTER || key === ESCAPE || key === UP_ARROW || key === DOWN_ARROW || key === LEFT_ARROW || key === RIGHT_ARROW);
};


/*
 * Returns the key name according to the Keyboard API specs
 * NOTE: e.key is not supported in Safari thus fallback to alias list
 *
 * @param   {Object} e - jQuery event
 * @returns {String}   - Key name
 */

whichKeyAlias = function(e) {
  return e.key || KEYLIST[e.which] || '';
};

module.exports = Keypress = {
  isCharKeyPress: isCharKeyPress,
  isDownArrowKey: isDownArrowKey,
  isEnterKey: isEnterKey,
  isEscapeKey: isEscapeKey,
  isTabKey: isTabKey,
  isUpArrowKey: isUpArrowKey,
  isValidCharKeyPress: isValidCharKeyPress,
  isValidKeyPress: isValidKeyPress,
  whichKeyAlias: whichKeyAlias
};

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).Common == null) {
  base1.Common = {};
}

_.extend(window.Groupon.Modules.SearchBar.Common, {
  Keypress: Keypress
});

//# sourceMappingURL=data:application/json;base64,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
